var DOWN_ARROW, ENTER, ESCAPE, KEYLIST, Keypress, LEFT_ARROW, RIGHT_ARROW, TAB, UP_ARROW, base, base1, isCharKeyPress, isDownArrowKey, isEnterKey, isEscapeKey, isTabKey, isUpArrowKey, isValidCharKeyPress, isValidKeyPress, whichKeyAlias;

TAB = 9;

ENTER = 13;

ESCAPE = 27;

DOWN_ARROW = 40;

RIGHT_ARROW = 39;

UP_ARROW = 38;

LEFT_ARROW = 37;

KEYLIST = {
  9: 'Tab',
  13: 'Enter',
  27: 'Escape',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown'
};

isTabKey = function(key) {
  return key === TAB;
};

isEnterKey = function(key) {
  return key === ENTER;
};

isEscapeKey = function(key) {
  return key === ESCAPE;
};

isUpArrowKey = function(key) {
  return key === UP_ARROW;
};

isDownArrowKey = function(key) {
  return key === DOWN_ARROW;
};


/*
 * Assert if key pressed is a normal character key
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key pressed is a normal character key
 */

isValidCharKeyPress = function(e) {
  if (e.which == null) {
    return false;
  }
  if (!isCharKeyPress(e)) {
    return false;
  }
  if (!isValidKeyPress(e.which)) {
    return false;
  }
  return true;
};


/*
 * Assert if key code is valid
 * and wasn't pressed with extra control keys
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key wasn't pressed with control keys
 */

isCharKeyPress = function(e) {
  if (typeof e.which === 'number' && e.which > 0) {
    return !e.ctrlKey && !e.metaKey && !e.altKey;
  }
  return false;
};


/*
 * Assert if key code is a navigational key
 *
 * @param   {Number}  key - Key code
 * @returns {Boolean}     - Assert if key is not a navigational key
 */

isValidKeyPress = function(key) {
  return !(key === TAB || key === ENTER || key === ESCAPE || key === UP_ARROW || key === DOWN_ARROW || key === LEFT_ARROW || key === RIGHT_ARROW);
};


/*
 * Returns the key name according to the Keyboard API specs
 * NOTE: e.key is not supported in Safari thus fallback to alias list
 *
 * @param   {Object} e - jQuery event
 * @returns {String}   - Key name
 */

whichKeyAlias = function(e) {
  return e.key || KEYLIST[e.which] || '';
};

module.exports = Keypress = {
  isCharKeyPress: isCharKeyPress,
  isDownArrowKey: isDownArrowKey,
  isEnterKey: isEnterKey,
  isEscapeKey: isEscapeKey,
  isTabKey: isTabKey,
  isUpArrowKey: isUpArrowKey,
  isValidCharKeyPress: isValidCharKeyPress,
  isValidKeyPress: isValidKeyPress,
  whichKeyAlias: whichKeyAlias
};

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).Common == null) {
  base1.Common = {};
}

_.extend(window.Groupon.Modules.SearchBar.Common, {
  Keypress: Keypress
});

//# sourceMappingURL=data:application/json;base64,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
